export const BA = "0x93BF5828f7AFff6139E704ba58fF87128E26C1e6";
export const TKNB = "0xcf0bea8b08fd28e339eff49f717a828f79f7f5ec";
export const TKNE = "0x29239242A83479a4074Cb1c9e2A3e6705A4A4455";
export const TKNA = "0xD7a24d22Cb1E94a4cF71E2E8338849382A7877bB";
export const TKNP = "0xD7a24d22Cb1E94a4cF71E2E8338849382A7877bB";
export const MSB = "0x1D806af1B153d7B28eEc042C9cBA585B05eB90b1";
export const MSE = "0x1904780aeAB48c05A846875eEFa3c8B234A17b8d";
export const MSA = "0x1904780aeAB48c05A846875eEFa3c8B234A17b8d";
export const MSP = "0x1904780aeAB48c05A846875eEFa3c8B234A17b8d";
export const ZERO = "0x0000000000000000000000000000000000000000";